import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaReceipt } from "react-icons/fa";
import PageLayout from "../../../components/layout/PageLayout";
import { Header } from "../../../components/ui";
import api from "../../../services/api";
import styles from "./ReceiptDebug.module.css";

const RECEIPT_STATUSES = ["Открыта", "Закрыта", "Не доставлено"];

export default function ReceiptDebug() {
  const { id } = useParams();
  const [receipt, setReceipt] = useState(null);
  const [markInputs, setMarkInputs] = useState({});

  useEffect(() => {
    api.get(`/receipts/${id}`).then(setReceipt);
  }, [id]);

  if (!receipt) {
    return (
      <PageLayout
        header={<Header icon={FaReceipt} title="Квитанция" subtitle="Загрузка…" />}
      >
        <p className={styles.loading}>Загрузка квитанции…</p>
      </PageLayout>
    );
  }

  const updateProduct = (productId, updater) => {
    setReceipt(prev => ({
      ...prev,
      products: prev.products.map(p =>
        p.id === productId ? updater(p) : p
      ),
    }));
  };

  const addMark = async (product) => {
    const value = markInputs[product.id]?.trim();
    if (!value) return;

    try {
      await api.post(`/products/${product.id}/marks`, {
        marks: [value],
      });

      updateProduct(product.id, p => ({
        ...p,
        marks: [...(p.marks || []), value],
      }));

      setMarkInputs(prev => ({ ...prev, [product.id]: "" }));
    } catch (err) {
      alert(err.response?.data?.error || "Ошибка добавления марки");
    }
  };

  const deleteMark = async (product, index) => {
    try {
      await api.delete(`/products/${product.id}/marks/${index}`);

      updateProduct(product.id, p => ({
        ...p,
        marks: p.marks.filter((_, i) => i !== index),
      }));
    } catch (err) {
      alert(err.response?.data?.error || "Ошибка удаления марки");
    }
  };

  return (
    <PageLayout
      header={
        <Header
          icon={FaReceipt}
          title={`Квитанция ${receipt.receipt_number}`}
          subtitle={`ID ${receipt.id}`}
        />
      }
    >
      <div className={styles.page}>
        <div className={styles.card}>
          {/* HEADER */}
          <div className={styles.top}>
            <div>
              <h3>Квитанция {receipt.receipt_number}</h3>
              <p>ID: {receipt.id}</p>
            </div>

            <select
              value={receipt.status}
              onChange={async e => {
                const v = e.target.value;
                await api.patch(`/receipts/${receipt.id}/status`, { status: v });
                setReceipt(prev => ({ ...prev, status: v }));
              }}
            >
              {RECEIPT_STATUSES.map(s => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>

          {/* META */}
          <div className={styles.metaGrid}>
            <div><span>Клиент</span><strong>{receipt.client_name}</strong></div>
            <div><span>Адрес</span><strong>{receipt.delivery_address}</strong></div>
            <div><span>Договор</span><strong>{receipt.contract_number}</strong></div>
            <div><span>Оплата</span><strong>{receipt.payment_method}</strong></div>
            <div><span>Время</span><strong>{receipt.time}</strong></div>
          </div>

          {/* PRODUCTS */}
          <div className={styles.products}>
            {receipt.products.map(p => (
              <div key={p.id} className={styles.product}>
                <div className={styles.productHeader}>
                  <strong>{p.product_name}</strong>
                  <span className={styles.muted}>
                    {p.actual_quantity} шт · № {p.product_number}
                  </span>
                </div>

                <div className={styles.marks}>
                  {p.marks?.map((m, i) => (
                    <span key={i} className={styles.mark}>
                      {m}
                      <button onClick={() => deleteMark(p, i)}>×</button>
                    </span>
                  ))}

                  <input
                    placeholder="+ марка"
                    value={markInputs[p.id] || ""}
                    onChange={e =>
                      setMarkInputs(prev => ({
                        ...prev,
                        [p.id]: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => addMark(p)}>+</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
